module.exports = __webpack_public_path__ + "img/Sandy_Headshot-photoaidcom-cropped.adaea367.JPG";